import React, { useEffect, useState } from 'react';
import { ChevronRight, LogOut, BadgePercent, User, DollarSign, MapPin, ShoppingBag } from 'lucide-react';
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from 'react-router-dom';
import LeftArrow from "../../assests/left-arrow.svg";
import VideoLoader from "../../components/VideoLoader";
import { useOrder } from "../../context/OrderContext";

export default function ProfilePage() {
  const { user, logout, currencySymbol, refreshBalances } = useAuth();
  // Balances change server-side (refunds, loyalty); show current values
  useEffect(() => {
    refreshBalances();
  }, [refreshBalances]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const { resetOrderContext } = useOrder();
//   if (!user) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <p className="text-gray-600">Loading profile...</p>
//         </div>
//       </div>
//     );
//   }

useEffect(() => {
  if (!user) {
    // navigate to home 
    navigate('/');
    setLoading(true);
  }
  else{
    setLoading(false)
  }
},[user]);

if (loading || !user) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 m-0" style={{ backgroundColor: 'var(--bw-bg)' }}>
      <VideoLoader size="medium" />
    </div>
  );
}



const menuItems = [
    {
        icon: <User className="w-5 h-5" />,
        title: 'My Account',
        subtitle: 'Edit profile, change password',
        onClick: () => navigate("/account")
    },
    {
        icon: <DollarSign className="w-5 h-5" />,
        title: 'Wallet',
        subtitle: 'Manage Your Wallet',
        onClick: () => navigate("/wallet")
    },
    {
        icon: <BadgePercent className="w-5 h-5" />,
        title: 'Rewards Program',
        subtitle: 'Grow with Loyalty Points and Discounts on your orders',
        onClick: () => navigate("/Loyalty")
    },
    {
        icon: <MapPin className="w-5 h-5" />,
        title: 'Addresses',
        subtitle: 'Manage your saved addresses',
        onClick: () => navigate("/address")
    },
    {
        icon: <ShoppingBag className="w-5 h-5" />,
        title: 'My Orders',
        subtitle: 'View your order history',
        onClick: () => navigate("/my-orders")
    },
    // {
    //     icon: <Wallet className="w-5 h-5" />,
    //     title: 'Payments',
    //     subtitle: 'Manage payment methods & wallet',
    //     color: 'text-purple-500'
    // },
    // {
    //     icon: <Gift className="w-5 h-5" />,
    //     title: 'Offers',
    //     subtitle: 'View available offers & coupons',
    //     color: 'text-pink-500'
    // },
    // {
    //     icon: <HelpCircle className="w-5 h-5" />,
    //     title: 'Help & Support',
    //     subtitle: 'Get help with your orders',
    //     color: 'text-indigo-500'
    // },
    // {
    //     icon: <Settings className="w-5 h-5" />,
    //     title: 'Settings',
    //     subtitle: 'Notification & app preferences',
    //     color: 'text-gray-500'
    // }
];

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Header */}
      <div className="bg-white sm:px-6 px-4 py-4">
        <div className="max-w-4xl mx-auto px-2 sm:px-4">
          <div className="flex items-center gap-3 sm:gap-4">
            <button
              className="p-2 rounded-full items-center flex justify-center w-[35px] h-[35px] border border-black/20 flex-shrink-0 text-black bg-white text-lg font-bold transition"
              onClick={() => navigate(-1)}
            >
              <img src={LeftArrow} alt="Back" className="w-4 h-4 dm-icon-invert" />
            </button>
            <span className="text-[18px] sm:text-[20px] font-bold text-black">Profile</span>
          </div>
        </div>
      </div>
      <div className="p-4 pt-0 sm:p-6">
        <div className="max-w-4xl mx-auto p-2 sm:p-4">
          {/* Profile Card */}
          <div className="text-black px-[12px] sm:px-[15px] py-[10px] bg-white border border-black/20 rounded-2xl">
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="flex flex-col sm:flex-row justify-between w-full items-start sm:items-center gap-3 sm:gap-0">
                <div className="flex gap-3 sm:gap-4 justify-start items-center flex-row w-full sm:w-auto">
                  <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] flex-shrink-0 rounded-full flex items-center justify-center text-2xl sm:text-3xl font-bold select-none" style={{ backgroundColor: 'var(--bw-black)', color: 'var(--bw-white)' }}>
                    {(user?.name || 'U').charAt(0).toUpperCase()}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h2 className="text-[18px] sm:text-[20px] font-bold mb-0 truncate text-black">{user?.name || 'User'}</h2>
                    <p className="text-gray-600 text-[13px] sm:text-[15px] mb-0 truncate">{user?.email}</p>
                    <p className="text-gray-600 text-[13px] sm:text-[15px] mb-0">{user?.phonenumber}</p>
                  </div>
                </div>
                <div className="mt-0 text-gray-700 font-normal flex flex-col justify-end items-start w-full sm:w-auto">
                  <span className="mt-0 mb-0 text-[12px] sm:text-[13px] whitespace-nowrap">
                    Wallet Balance: {currencySymbol}{(user?.wallet?.balance ?? 0).toFixed(2)}
                  </span>
                  <span className="text-[13px] sm:text-[13px] whitespace-nowrap">
                    Cash Earned Balance: {currencySymbol}{(user?.bonusWallet?.balance ?? 0).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
     

      {/* Menu Items */}
      <div className="max-w-4xl mx-auto p-2 sm:p-4 pt-1 pb-20">
        <div className="bg-white py-3 px-2 sm:px-3 border border-black/20 rounded-2xl overflow-hidden">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.onClick}
              className="w-full flex items-center gap-3 sm:gap-4 px-[12px] sm:px-[15px] py-[16px] sm:py-[20px] transition border-b border-black/10 last:border-b-0 text-black"
            >
              <div className="p-2 bg-transparent w-[40px] h-[40px] sm:w-[45px] sm:h-[45px] flex-shrink-0 border border-black/20 rounded-full flex items-center justify-center text-black">
                {item.icon}
              </div>
              <div className="flex flex-col flex-1 text-left min-w-0">
                <h3 className="font-bold text-[17px] sm:text-[19px] text-black mb-[2px]">{item.title}</h3>
                <p className="text-[12px] sm:text-[13px] text-gray-700 font-normal mb-0 line-clamp-2">{item.subtitle}</p>
              </div>
              <ChevronRight className="w-5 h-5 flex-shrink-0 text-gray-600" />
            </button>
          ))}
        </div>

        <button
          onClick={() => {
            logout();
            resetOrderContext();
            navigate('/');
          }}
          className="dm-profile-logout w-full mt-6 bg-black border border-black/20 rounded-[15px] p-3 sm:p-4 flex items-center justify-center gap-3 text-white font-semibold transition"
        >
          <LogOut className="w-5 h-5" />
          Logout
        </button>

        {/* Footer Info */}
        <div className="text-center mt-8 text-gray-700 text-xs sm:text-sm">
          <p>Version 1.0.0</p>
          <p className="mt-2">© 2025 Food Delivery App</p>
        </div>
      </div>
      </div>
    </div>
  );
}
